import { ROUTES } from '@/lib/routes';

export const data = [
  {
    title: 'Admin Panel',
    authPath: `${ROUTES.SIGN_IN}?section=admin_panel`,
    path: ROUTES.ADMIN_USERS,
    image: '/icons/admin_panel.svg',
    active: true,
  },
  {
    title: 'Previewer',
    authPath: `${ROUTES.SIGN_IN}?section=previewer`,
    path: ROUTES.PREVIEWER,
    image: '/icons/content_management.svg',
    active: true,
  },
  {
    title: 'Pricing Tariffs',
    authPath: `${ROUTES.SIGN_IN}?section=pricing_plans`,
    path: ROUTES.TARIFFS,
    image: '/icons/pricing_plans.svg',
    active: true,
  },
];
